export default "__VITE_ASSET__BEzIHtT3__"